import React from "react";
import { Dialog, Flex, Button } from "@radix-ui/themes";

export function SevenRoomsChoiceDialog({ isOpen, onOpenChange, data, onChoose }) {
  if (!data) return null;

  const { message, deleted_at } = data;
  const options = ["resume", "continue_from_now"];

  const choiceLabels = {
    resume: "Resume Syncing",
    continue_from_now: "Continue from Now",
  };

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="500px">
        <Dialog.Title>Previous SevenRooms Integration Detected</Dialog.Title>

        <Dialog.Description size="2" mb="4">
          {message}
          {deleted_at && (
            <>
              <br />
              Last deleted on: <strong>{new Date(deleted_at).toLocaleString()}</strong>
            </>
          )}
          <br />
          Would you like to resume syncing from before deletion or start fresh from now?
        </Dialog.Description>

        <Flex justify="end" gap="3" wrap="wrap">
          {options.map((opt) => (
            <Button
              key={opt}
              variant={opt === "resume" ? "soft" : "outline"}
              color={opt === "resume" ? "accent" : "gray"}
              onClick={() => onChoose(opt)}
            >
              {choiceLabels[opt]}
            </Button>
          ))}
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
